import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {ChevronDownIcon, ChevronRightIcon} from '@/components/ui/icon/Icon'
import {ReactNode} from 'react'
import {
    StyledAgendaSidebarViewAccordionWrapper,
    StyledViewAccordionButton
} from '@/features/agenda/components/agenda-sidebar-accordion/style'
import {useTranslation} from '@/translations/i18n'
import {PatientAgeRange} from '@/types'
import {workServiceToLabel} from '@/utilities/helpers'

export const AgendaSidebarAccordion = ({
    accordionItemLabel,
    setSelectedAccordion,
    selectedAccordion,
    children
}: {
    accordionItemLabel: PatientAgeRange
    setSelectedAccordion: (selectedAccordion: string | null) => void
    selectedAccordion: string | null
    children: ReactNode
}) => {
    const {t} = useTranslation()

    const handleClick = (accordionItemLabel: PatientAgeRange) => {
        setSelectedAccordion(accordionItemLabel == selectedAccordion ? null : accordionItemLabel)
    }

    return (
        <StyledAgendaSidebarViewAccordionWrapper>
            <Flexbox direction="column" gap={2.5} fullWidth>
                <StyledViewAccordionButton
                    onClick={() => handleClick(accordionItemLabel)}
                    shape="text"
                    variant="ghost"
                    fullWidth
                >
                    {t(workServiceToLabel[accordionItemLabel])}
                    {selectedAccordion == accordionItemLabel ? <ChevronDownIcon /> : <ChevronRightIcon />}
                </StyledViewAccordionButton>
                {selectedAccordion == accordionItemLabel && children}
            </Flexbox>
        </StyledAgendaSidebarViewAccordionWrapper>
    )
}
